
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/showcase/data-portals",
      function () {
        return require("private-next-pages/showcase/data-portals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/showcase/data-portals"])
      });
    }
  